// ABOUTME: Dealership line of the cart's header: one cart per dealership, "Change" switches to another one's cart.
// ABOUTME: Hidden with one dealership or none; the picker lists each dealership with its cart's lines.

import { useCallback } from 'react';

import { useDealershipChoice } from '../context/DealershipChoiceContext';
import type { DealershipChoice } from '../types';
import { DealershipLabel } from './DealershipLabel';

type CartDealershipLabelProps = {
    /** the lines of the user's cart in each dealership (undefined key: "None (company)") */
    itemCounts?: ReadonlyMap<string | undefined, number>;
    /** the width of the column the icon is centred in, as the cart's line images */
    iconColumnWidth?: string;
};

export function CartDealershipLabel({ itemCounts, iconColumnWidth }: CartDealershipLabelProps) {
    const { cartDealership, chooseCartDealership, chooseDealership } = useDealershipChoice();

    const change = useCallback(async () => {
        const current: DealershipChoice = cartDealership
            ? { kind: 'dealership', dealershipId: cartDealership }
            : { kind: 'none' };
        const choice = await chooseDealership(current, {
            isChange: true,
            optionCounts: itemCounts,
        }).catch(() => undefined);
        if (!choice) return;
        chooseCartDealership(choice.kind === 'dealership' ? choice.dealershipId : undefined);
    }, [cartDealership, chooseCartDealership, chooseDealership, itemCounts]);

    return (
        <DealershipLabel
            dealershipId={cartDealership}
            onChange={change}
            buttonAtEnd
            hideWithoutChoice
            listRow
            iconColumnWidth={iconColumnWidth}
        />
    );
}

export default CartDealershipLabel;
